"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Faction = void 0;
var Faction;
(function (Faction) {
    Faction[Faction["Ally"] = 0] = "Ally";
    Faction[Faction["Enemy"] = 1] = "Enemy";
    Faction[Faction["Game"] = 1000] = "Game";
})(Faction = exports.Faction || (exports.Faction = {}));
